<template>
    <ies-form-field :field="field">
        <v-layout row wrap>
            <v-col cols="3">
                <v-btn v-on:click="chooseHotel" 
                       v-show="!shouldShowPicker">{{ buttonLabel }}</v-btn>
                <v-btn v-on:click="clearHotel" 
                       v-show="selectedHotel">Clear</v-btn>
				            </v-col>

	            <v-col cols="10" v-if="shouldShowPicker">
                <v-container>
                    <v-layout row wrap>
 
                        <v-col cols="10">
                            <v-text-field hide-details
                                v-model="hotelViewName" 
                                v-on:keyup="updateHotelName()"
								:required="this.field.required" 
                             ></v-text-field>

                             <div class="selectable-hotels-results" v-if="hotelOptions.length && shouldShowHotels">
                                 <ul class="selectable-hotels-list">
                                     <li v-for="hotel in hotelOptions" v-on:click="selectHotel(hotel.hotel_key)">({{ hotel.hotel_code }}) {{ hotel.hotel_name }}{{ !hotel.display ? " (offline)" : "" }}{{ !hotel.bookable_via_iescape ? " (not bookable)" : "" }}</li>
                                 </ul>
                             </div>
                         </v-col>
<!--
                          <v-col cols="12">
                              <v-btn v-on:click="done">Done</v-btn>
                          </v-col>
-->
                   </v-layout>
               </v-container>
           </v-col>

           <input type="hidden" :name="field.fieldName" :value="field.value">
        </v-layout>
    </ies-form-field>
</template>

<script>
    /**
     * Allows the selection of a hotel ID by choosing its name or code from
     * a selection downloaded from the API on creation
     *
     * @todo refactor, make more efficient
     */
    export default {
        name: 'ies-hotelKey',
        props: ['field', 'configuration', 'page'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                /** string view model */
                hotelViewName: '',

                /** array of hotel options presented to the user */
                hotelOptions: [],

                /** data model of all supported hotels */
                hotels: [],

                /** view model to determine whether the hotel  picker should display */
                shouldShowPicker: true,

                /** The hotel chosen by the user */
                viewValue: parseInt(this.field.value),

                selectedHotel: null,

                /** For where the component is used in event mode to talk to other components */
                config: {'shouldEmitOnSelect': false, 'selectEventName': ''}
            }
        },
        created:function() {
            console.log("****** HOTEL *******", this);
            console.log("this page", this.page);
            console.log(this.page && this.page.edit_url ? this.page.edit_url : "No page");

            if (!this.field.value){
                this.setDefaultValueFromUrl();
            }

            // Load the hotels list from the server
            this.getHotels();

            if (this.configuration){
                var config = JSON.parse(this.configuration);
                console.log(config);
                if (config.shouldEmitOnSelect && config.selectEventName){
                    this.config.shouldEmitOnSelect = config.shouldEmitOnSelect;
                    this.config.selectEventName = config.selectEventName;
                }
            }

            // We may want to move this into the configuration rather than assume all of the instances may need to listen
            this.addEventListeners();
        },

        methods: {
            setDefaultValueFromUrl: function(){
                // Only try to use the data if it is set, otherwise it will simply crash
                if (!this.page || !this.page.edit_url){
                    return;
                }

                // Find out if the URL has a hotel ID in it
                // by checking the edit url pattern for one
                // and making a note of which part it is in
                var bits = this.page.edit_url.split('/');
                var foundIndex = null;
                bits.forEach(function(bit, index){
                    if (bit == '{Hotel.hotel_key}'){
                        console.log("found it ", bit, index);
                        foundIndex = index;
                    }
                });

                // If we found a hotel key in the url pattern
                // then extract the value from the current page
                // url at that part
                var selectedHotelKey = null;
                if (foundIndex !== null){
                    var urlBits = location.pathname.split('/').splice(1);
                    console.log(urlBits);
                    console.log("hotel key from url is ", urlBits[foundIndex]);
                    selectedHotelKey = urlBits[foundIndex];

                    // The field value is set to that value by default
                    this.field.value = parseInt(selectedHotelKey);
                }
            },

            addEventListeners: function(){
                var self = this;

                this.$root.$on('Hotel Key: set', function(payload){
                    console.log("Have heard ", payload);
                    if (payload.hotelKey){
                        self.selectHotel(payload.hotelKey);
                    }
                    else {
                        self.clearHotel();
                    }
                });
            },
			
	            getHotels:function(){
                var self = this;
                axios.get('/api/hotelsWithRooms')
                .then(function(response){
                    this.hotels = response.data;
                    this.hotels.forEach(function(hotel){
                        if (hotel.hotel_key == self.field.value){
                            self.selectedHotel = hotel;

                            // Set the view models so that it is reflected to the users
                            self.hotelViewName = hotel.hotel_name;
                        }
                    });
                }.bind(this));
            },

            updateHotelName: function(){
                if (this.hotelTypeTimer){
                    clearTimeout(this.hotelTypeTimer);
                }
                this.hotelTypeTimer = setTimeout(this.refineHotelOptions, 333);
           },


            refineHotelOptions: function(){
                var self = this;
 
                var hotelOptions = [];
                this.hotels.forEach(function(hotel){
                    if (hotel.hotel_code.toLowerCase().includes(self.hotelViewName.toLowerCase()) || hotel.hotel_name.toLowerCase().includes(self.hotelViewName.toLowerCase())){
                        hotelOptions.push(hotel);
                    }
                });
                this.hotelOptions = hotelOptions;

                // If there is only one hotel left in the list of options then we select it
                if (this.hotelOptions.length === 1){
                    this.selectedHotel = this.hotelOptions[0];
                    this.updateFieldValue();
                }
                this.shouldShowHotels = true;
            },

            selectHotel: function(hotelKey){
                var self = this;
                this.hotels.forEach(function(hotel){
                    if (hotel.hotel_key === hotelKey){
                        self.selectedHotel = hotel;
                        self.hotelViewName = hotel.hotel_name;
                        self.updateFieldValue();
                    }
                });
                this.shouldShowHotels = false;
            },

            chooseHotel: function(){
                this.shouldShowPicker = true;
            },

            clearHotel: function(){
                this.selectedHotel = null;
                this.hotelViewName = '';
                this.field.value = null;

                if (this.config.shouldEmitOnSelect){
                    console.log("I should emit ", this.config.selectEventName);
                    this.$root.$emit(this.config.selectEventName, {hotelKey: null});
                }
            },

            done: function(){
                this.shouldShowPicker = false;
            },

            updateFieldValue: function(){
                this.field.value = this.selectedHotel.hotel_key;

                console.log("updatefieldvalue on select: ", this.config);
                if (this.config.shouldEmitOnSelect){
                    console.log("I should emit ", this.config.selectEventName);
                    this.$root.$emit(this.config.selectEventName, {hotelKey: this.field.value});
                }
            }
        },
        watch: {
            viewValue: function (newValue) {
            }
        },
        computed: {
            buttonLabel: function(){
                return this.selectedHotel ? "(" + this.selectedHotel.hotel_code + ") " + this.selectedHotel.hotel_name : "Choose";
            }
        }

    }
</script>

<style>
.selectable-hotels-results{
    background-color: white;
    border: solid 1px #f5f5f5;
    width: auto;
    min-width: 20rem;
    max-height: 10rem;
    overflow-y: auto;
    position: absolute;
    z-index: 1;
}

.selectable-hotels-list {
  list-style-type: none;
}

.selectable-hotels-list li {
    cursor: pointer;
    padding: 3px;
}

.selectable-hotels-list li:hover {
    background-color: #f5f5f5;
}
</style>
